import * as React from "react";
import { merge, $, keyframes } from "glamor";
import { formatMessage } from "lib/globalize-util";
import IconButton from "material-ui/IconButton";
import CircularProgress from "material-ui/CircularProgress";
import { DATATEST } from "constants/integration";
import IconMenu from "material-ui/IconMenu";
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert";
import MenuItem from "material-ui/MenuItem";
import Divider from "material-ui/Divider";
import { CUSTOM_VIEW_SETTINGS, DEFAULT_VIEW_SETTINGS } from "../manage-tile-view/constants";
import CheckIcon from "@material-ui/icons/Check";
import { theme } from "styles/theme";
import exportStyles from "../product-collection-header-components/export-styles";
import MuiDialog from "material-ui/Dialog";

const spin = keyframes({
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(-360deg)" },
});

export const CatalogActions: React.FunctionComponent<{
    onAddAllItems: () => void;
    onResetToDefaultShopView?: () => void;
    onConfigureShopView?: () => void;
    disabled?: boolean;
    style?: React.CSSProperties;
    bulkAddingItems: boolean;
    selectedShopViewKey?: string;
    isCatalogPage?: boolean;
}> = ({
    onAddAllItems,
    disabled,
    style,
    bulkAddingItems,
    onResetToDefaultShopView,
    onConfigureShopView,
    selectedShopViewKey,
    isCatalogPage,
}) => {
    const styles = React.useMemo(() => {
        return merge(
            $(" .syncingProducts", {
                animation: `${spin} 2s infinite linear`,
            })
        );
    }, []);

    const muiStyles = {
        selectedMenuItem: {
            color: theme.palette.primary1Color,
        },
    };
    return (
        <div {...styles}>
            {bulkAddingItems ? (
                <MuiDialog
                    open={bulkAddingItems}
                    title={formatMessage("Saving changes")}
                    titleStyle={{ marginLeft: "10px", lineHeight: "46px" }}
                    contentStyle={{ maxWidth: "600px" }}
                >
                    <div {...exportStyles} className="loadingExport closeButton">
                        <CircularProgress />
                        <p>{formatMessage("Please wait while we save your changes")}</p>
                    </div>
                </MuiDialog>
            ) : (
                <IconMenu
                    iconButtonElement={
                        <IconButton data-test={DATATEST.ASSORTMENTS.SHOP_ACTION_MENU} style={style}>
                            <MoreVertIcon />
                        </IconButton>
                    }
                    anchorOrigin={{ horizontal: "right", vertical: "top" }}
                    targetOrigin={{ horizontal: "right", vertical: "top" }}
                    useLayerForClickAway={true}
                >
                    {selectedShopViewKey && (
                        <MenuItem
                            data-test={DATATEST.ASSORTMENTS.SHOP_VIEW_DEFAULT_SETTINGS_BTN}
                            onClick={onResetToDefaultShopView}
                        >
                            {formatMessage("Default Configuration")}
                            {selectedShopViewKey === DEFAULT_VIEW_SETTINGS ? (
                                <CheckIcon style={muiStyles.selectedMenuItem} />
                            ) : null}
                        </MenuItem>
                    )}
                    {selectedShopViewKey && <Divider />}
                    {selectedShopViewKey && (
                        <MenuItem
                            data-test={DATATEST.ASSORTMENTS.SHOP_VIEW_CONFIGURE_BTN}
                            onClick={onConfigureShopView}
                        >
                            {formatMessage("Configure Shop View")}
                            {selectedShopViewKey === CUSTOM_VIEW_SETTINGS ? (
                                <CheckIcon style={muiStyles.selectedMenuItem} />
                            ) : null}
                        </MenuItem>
                    )}
                    {isCatalogPage && (
                        <MenuItem
                            data-test={DATATEST.ASSORTMENTS.SHOP_ADD_ALL_PRODUCTS}
                            primaryText={formatMessage("Add all products")}
                            onClick={onAddAllItems}
                            disabled={disabled}
                        />
                    )}
                </IconMenu>
            )}
        </div>
    );
};
